import { render, staticRenderFns } from "./coderAmbulatoryList.vue?vue&type=template&id=288b66a2&scoped=true&"
import script from "./coderAmbulatoryList.vue?vue&type=script&lang=js&"
export * from "./coderAmbulatoryList.vue?vue&type=script&lang=js&"
import style0 from "./coderAmbulatoryList.vue?vue&type=style&index=0&id=288b66a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288b66a2",
  null
  
)

export default component.exports